export * from "./settingScreen";
